import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'styles/font/iconfont.css'

const isDev =  process.env.NODE_ENV === 'development'

Vue.config.productionTip = isDev
Vue.config.devtools = isDev

Vue.use(ElementUI)

// 尺寸适配
if(window.screen.width < 750) {
  document.querySelector('body').style.overflow = 'auto';
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js